import React from 'react';

const CustomerAccount = React.createContext('TEST01');  // Create our context
export default CustomerAccount;